import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=245e5c58&scoped=true"
import script from "./LazyImage.js?vue&type=script&lang=js&external"
export * from "./LazyImage.js?vue&type=script&lang=js&external"
import style0 from "./LazyImage.scss?vue&type=style&index=0&id=245e5c58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e5c58",
  null
  
)

export default component.exports